import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/node_modules/gatsby-theme-docz/src/base/Layout.js";
import { Reference, Property, Name, Output } from '@components/Reference';
import Sandbox from '@components/Sandbox';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">




    <h1 {...{
      "id": "overflow"
    }}>{`Overflow`}</h1>
    <p>{`Overflow classes to change an elements overflow properties`}</p>
    <h2 {...{
      "id": "class-reference"
    }}>{`Class reference`}</h2>
    <Reference mdxType="Reference">
    <Property mdxType="Property">
        <Name mdxType="Name">.o-auto</Name>
        <Output mdxType="Output">overflow: auto;</Output>
    </Property>
    <Property mdxType="Property">
        <Name mdxType="Name">.ox-auto</Name>
        <Output mdxType="Output">overflow-x: auto;</Output>
    </Property>
    <Property mdxType="Property">
        <Name mdxType="Name">.oy-auto</Name>
        <Output mdxType="Output">overflow-y: auto;</Output>
    </Property>
    <Property mdxType="Property">
        <Name mdxType="Name">.o-scroll</Name>
        <Output mdxType="Output">overflow: scroll;</Output>
    </Property>
    <Property mdxType="Property">
        <Name mdxType="Name">.ox-scroll</Name>
        <Output mdxType="Output">overflow-x: scroll;</Output>
    </Property>
    <Property mdxType="Property">
        <Name mdxType="Name">.oy-scroll</Name>
        <Output mdxType="Output">overflow-y: scroll;</Output>
    </Property>
    <Property mdxType="Property">
        <Name mdxType="Name">.o-hidden</Name>
        <Output mdxType="Output">overflow: hidden;</Output>
    </Property>
    <Property mdxType="Property">
        <Name mdxType="Name">.ox-hidden</Name>
        <Output mdxType="Output">overflow-x: hidden;</Output>
    </Property>
    <Property mdxType="Property">
        <Name mdxType="Name">.oy-hidden</Name>
        <Output mdxType="Output">overflow-y: hidden;</Output>
    </Property>
    <Property mdxType="Property">
        <Name mdxType="Name">.o-visible</Name>
        <Output mdxType="Output">overflow: visible;</Output>
    </Property>
    </Reference>
    <h2 {...{
      "id": "auto"
    }}>{`Auto`}</h2>
    <p><inlineCode parentName="p">{`.o-auto`}</inlineCode>{` adds scrollbars when required and extends the content in all directions.`}</p>
    <Sandbox mdxType="Sandbox">
  <Sandbox.Preview>
    <div className="d-inline-block h-15 bg-secondary-100 p-2 o-auto">
      <p>
        Mi mauris venenatis penatibus sem pulvinar volutpat tellus suscipit elementum euismod, pharetra per faucibus scelerisque justo senectus cursus id laoreet viverra maximus, blandit molestie sed purus curae dapibus sociosqu lorem ligula.
      </p>
    </div>
  </Sandbox.Preview>
  <Sandbox.Code>
    <div className="o-auto">...</div>
  </Sandbox.Code>
    </Sandbox>
    <h2 {...{
      "id": "scroll"
    }}>{`Scroll`}</h2>
    <p><inlineCode parentName="p">{`.o-scroll`}</inlineCode>{` adds scrollbars even if scrolling is not required.`}</p>
    <Sandbox mdxType="Sandbox">
  <Sandbox.Preview>
    <div className="d-inline-block h-15 bg-secondary-100 p-2 o-auto">
      <p>
        Mi mauris venenatis penatibus sem pulvinar volutpat tellus suscipit elementum euismod, pharetra per faucibus scelerisque justo senectus cursus id laoreet viverra maximus, blandit molestie sed purus curae dapibus sociosqu lorem ligula.
      </p>
    </div>
  </Sandbox.Preview>
  <Sandbox.Code>
    <div className="o-scroll">...</div>
  </Sandbox.Code>
    </Sandbox>
    <h2 {...{
      "id": "hidden"
    }}>{`Hidden`}</h2>
    <p><inlineCode parentName="p">{`.o-hidden`}</inlineCode>{` cuts off children elements, which exceed its bounds.`}</p>
    <Sandbox mdxType="Sandbox">
  <Sandbox.Preview>
    <div className="d-inline-block h-15 bg-secondary-100 p-2 o-hidden">
      <p>
        Mi mauris venenatis penatibus sem pulvinar volutpat tellus suscipit elementum euismod, pharetra per faucibus scelerisque justo senectus cursus id laoreet viverra maximus, blandit molestie sed purus curae dapibus sociosqu lorem ligula.
      </p>
    </div>
  </Sandbox.Preview>
  <Sandbox.Code>
    <div className="o-hidden">...</div>
  </Sandbox.Code>
    </Sandbox>
    <h2 {...{
      "id": "visible"
    }}>{`Visible`}</h2>
    <p><inlineCode parentName="p">{`.o-visible`}</inlineCode>{` allows children exceeding its bounds to be visible.`}</p>
    <Sandbox mdxType="Sandbox">
  <Sandbox.Preview>
    <div className="d-inline-block h-15 bg-secondary-100 p-2 o-visible">
      <p>
        Mi mauris venenatis penatibus sem pulvinar volutpat tellus suscipit elementum euismod, pharetra per faucibus scelerisque justo senectus cursus id laoreet viverra maximus, blandit molestie sed purus curae dapibus sociosqu lorem ligula.
      </p>
    </div>
  </Sandbox.Preview>
  <Sandbox.Code>
    <div className="o-visible">...</div>
  </Sandbox.Code>
    </Sandbox>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      